import React from "react";
import "../styles/Requestcall.css";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const RequestCall = () => {
  const navigate = useNavigate();

  const toggleForm = () => {
    navigate("/contact");
  };

  return (
    <div className="requestcallvisible">
      <div className="fixed-whatsapp">
        <div className="">
          <a
            href="https://wa.me/9487812715"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
          >
            <img src="/images/whatsapp.webp" className="reqcall" alt="" height="30px" width= "30px" loading="lazy"/>
            <span>Whatsapp</span>
          </a>
        </div>
        <div className="verticaline"></div>
        <div className="">
          <a
            href="tel:+918508508590"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-number"
          >
            <img src="/images/phone.webp" className="reqcall" alt="" height="30px" width= "30px" loading="lazy"/>
            <span>Call us</span>
          </a>
        </div>
      </div>
      {/* <button className="request-button" onClick={toggleForm}>
        Request a Call
      </button> */}
      {/* <div className={`form-containerr ${isOpen ? "open" : ""}`}>
        <div className="form-header">
          <h3>Request a Call</h3>
          <button className="close-button" onClick={toggleForm}>
            X
          </button>
        </div>
        <form onSubmit={handleSubmit} className="recall">
          <div className="recall1">
            <label>
              Enter First Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              className="inputcall"
              required
            />
          </div>
          <div className="recall1">
            <label>
              Enter Last Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              className="inputcall"
              required
            />
          </div>
          <div className="recall1">
            <label>
              Enter Phone Number <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone} // <-- This should now update correctly
              onChange={handleChange}
              className="inputcall"
              pattern="[0-9]{10}"
              required
            />
          </div>
          <div className="recall1">
            <label>
              Enter Email <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="inputcall"
              required
            />
          </div>
          <div className="recall1">
            <label>
              Enter Message <span className="required">*</span>
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="inputcall"
              required
            />
          </div>
          <button type="submit" className="submit-button">
            SUBMIT
          </button>
        </form>
      </div> */}
    </div>
  );
};

export default RequestCall;
